import {Box, Container} from '@mui/material';
import type * as React from 'react';

const PageNotFound = (): React.ReactElement => {
    return (
        <Container maxWidth='sm'>
            <Box
                sx={{typography: 'h4',
                    textAlign: 'center',
                    pt: 3,
                    mt: 3,
                    color: '#fff',
                }}
            >Page NOT FOUND</Box>
        </Container>
    );
};

export default PageNotFound;
